module.exports = __webpack_public_path__ + "odinstatic/v17.0.0/media/manual-placement.9726886b.svg";